import { render, staticRenderFns } from "./passSolution.vue?vue&type=template&id=06d2c206&scoped=true&"
import script from "./passSolution.vue?vue&type=script&lang=js&"
export * from "./passSolution.vue?vue&type=script&lang=js&"
import style0 from "./passSolution.vue?vue&type=style&index=0&id=06d2c206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2c206",
  null
  
)

export default component.exports